module.exports = function (data) {
    return {
        event: 'BWSAUNotifyMe',
        eventContext: {
            area: data.area,
            postcode: data.postcode,
            suburb: data.suburb,
            state: data.state,
            reason: data.reason
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/atmmapper/notify-me-analytics-mapper.js
 **/